import { useNavigate, useSearchParams } from "react-router-dom";
import { useToast } from "@/hooks/use-toast";
import { getAppUrl } from "@lyder-talk/core";
import { ForgotPasswordForm } from "@lyder-talk/ui";
import { useTranslation } from "react-i18next";
import { auth } from "@lyder-talk/core/lib/auth-client";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const { toast } = useToast();

  const redirectTo = searchParams.get("redirectTo");
  const redirectQuery = redirectTo ? `?redirectTo=${encodeURIComponent(redirectTo)}` : "";

  const handleSubmit = async (email: string) => {
    try {
      const { error } = await auth.resetPasswordForEmail(email, {
        redirectTo: getAppUrl('/auth/reset-password'),
      });

      if (error) throw new Error(error.message);
    } catch (error: unknown) {
      let errorMessage = t("auth.forms.forgot.sendFailed");
      if (error instanceof Error) {
        errorMessage = error.message;
      }

      toast({
        title: t("auth.forms.toasts.error", "Error"),
        description: errorMessage,
        variant: "destructive",
      });
      throw error;
    }
  };

  return (
    <ForgotPasswordForm
      onSubmit={handleSubmit}
      onNavigateToSignin={() => navigate(`/auth/signin${redirectQuery}`)}
      copy={{
        title: t("auth.forms.forgot.title"),
        description: t("auth.forms.forgot.description"),
        emailLabel: t("auth.forms.forgot.emailLabel"),
        sending: t("auth.forms.forgot.sending"),
        submit: t("auth.forms.forgot.submit"),
        backToSignIn: t("auth.forms.forgot.backToSignIn"),
        sentTitle: t("auth.forms.forgot.sentTitle"),
        sentDescription: (email) => t("auth.forms.forgot.sentDescription", { email }),
        tryAnotherEmail: t("auth.forms.forgot.tryAnotherEmail"),
        sendFailed: t("auth.forms.forgot.sendFailed"),
      }}
    />
  );
};

export default ForgotPassword;
